import React from 'react'
import { connect } from 'redaction'
import useWillMount from 'sb-hooks/useWillMount'
import PropTypes from 'prop-types'
import { IntlContext, IntlProvider } from 'sb-react-intl'
import intl from 'sb-react-intl/intl'


const LanguageProvider = ({ children, locale, messages }) => {
  useWillMount(() => {
    intl.setLocale(locale)
  })

  return (
    <IntlContext.Provider value={intl}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        {children}
      </IntlProvider>
    </IntlContext.Provider>
  )
}

LanguageProvider.propTypes = {
  locale: PropTypes.string,
  messages: PropTypes.object,
  children: PropTypes.node.isRequired,
}

export default connect({
  locale: 'models.ui.locale',
})(LanguageProvider)
